import { useDispatch } from 'react-redux';
import { useMutation } from 'react-query';
import { wellnub } from 'network/wellnub.api';
import { setNutritionists } from 'features/nutritionists/state/nutritionists.slice';

const queryFn = async options => {
  // Query params:
  // keySpecialties=["inmunonutrition", "malnutrition"]
  // diets=["630f50d14b9dee0e3ed67c96"]
  // nutriTypes
  const { queryParams } = options || {};
  const baseUrl = '/v1/client/user/nutritionist';
  const url = queryParams ? baseUrl + queryParams : baseUrl;

  const { data } = await wellnub.get(url);
  return data;
};

export const useGetNutritionistsService = () => {
  const dispatch = useDispatch();

  return useMutation('GET_NUTRITIONISTS', queryFn, {
    onSuccess: data => {
      dispatch(setNutritionists(data));
    },
  });
};
